import { CollectionViewer } from "@angular/cdk/collections";
import { DataSource } from "@angular/cdk/table";
import { BehaviorSubject, Observable, of } from "rxjs";
import { ApiHttpService } from "../core/api-http.service";
import {finalize, catchError} from 'rxjs/operators';


export class AcceptListDataSource implements DataSource<any> {

    private acceptListSubject = new BehaviorSubject<any[]>([]);
    private totalElements;
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();

    constructor(private httpService: ApiHttpService) {}

    connect(httpService: CollectionViewer): Observable<any[]> {
        return this.acceptListSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.acceptListSubject.complete();
        this.loadingSubject.complete();
    }

    loadAcceptList(surrogatePan?: string,truncatedPan?:string, pageIndex = 0, pageSize = 10) {

      this.loadingSubject.next(true);

      this.httpService.searchAcceptList(surrogatePan, truncatedPan, pageIndex, pageSize).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        )
      .subscribe(eventlogs => { this.acceptListSubject.next(eventlogs.content);this.totalElements = eventlogs.page.totalElements; });
    }

    total(){
      return this.totalElements;
    }

    loadAcceptListAll(pageIndex = 0, pageSize = 10) {

      this.loadingSubject.next(true);

      this.httpService.searchAcceptList(null, null,pageIndex ,pageSize).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        )
      .subscribe(eventlogs => this.acceptListSubject.next(eventlogs));
  }
}
